import {BaseFirebaseModel} from '../bases/baseFirebaseModel';

export class Practice extends BaseFirebaseModel {
	isChecked: boolean = false;
	Name: string = '';
	name?: string;
	id?: string;
	private initValue?: Practice;

	constructor(obj: Record<string, unknown>) {
		super();
		const nameValue = obj['name'] ?? '';
		const NameValue = obj['Name'] ?? '';
		this.Name = String(nameValue) + String(NameValue);
		this.name = undefined;
	}

	firestoreUpdate() {
		const update = new Map();
		if (this.initValue) {
			if (this.initValue.Name !== this.Name && this.Name !== undefined) {
				update.set('Name', this.Name);
			}
			if (this.id) {
				this.uuid = this.id;
				this.id = undefined;
				update.set('uuid', this.uuid);
				update.set('id', null);
			}
		}
		return update;
	}
}

export const PracticeConverter = {
	toFirestore: (practice: Practice) => {
		return practice.firestoreUpdate();
	},
	fromFirestore: (snapshot: { data: (options?: unknown) => Record<string, unknown> }, options?: unknown) => Practice.fromObject(snapshot.data(options))
};
